import React from 'react';

export const MaintenancePage = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: '#5e3a1c' }}
    >
      <div className="text-center max-w-lg">
        <img 
          src="https://customer-assets.emergentagent.com/job_leaf-lounge-3/artifacts/kbshdl1e_file_00000000646471fdbb03789bab2f6e30.png" 
          alt="Mudbutt Brew"
          className="h-40 w-auto mx-auto mb-8"
        />
        <h1 
          className="text-4xl md:text-5xl font-bold mb-4"
          style={{ color: '#f5e9d0', fontFamily: 'Georgia, serif' }}
        >
          Coming Soon
        </h1>
        <p 
          className="text-lg mb-8"
          style={{ color: '#c2a357' }}
        >
          We're brewing something special. Our website is currently under construction.
        </p>
        <div 
          className="p-6 rounded-lg"
          style={{ backgroundColor: 'rgba(194, 163, 87, 0.1)', border: '1px solid #c2a357' }}
        >
          <p style={{ color: '#c2a357' }}>
            <strong style={{ color: '#f5e9d0' }}>Questions?</strong>
            <br />
            Email us at{' '}
            <a 
              href="mailto:mudbuttbrewinfo@protonmail.com"
              className="underline hover:opacity-80"
              style={{ color: '#f5e9d0' }}
            >
              mudbuttbrewinfo@protonmail.com
            </a>
          </p>
        </div>
        <p 
          className="mt-8 text-sm"
          style={{ color: '#8b5c2f' }}
        >
          Rooted in Tradition, Crafted with Nature
          <br />
          Elma, Washington
        </p>
      </div>
    </div>
  );
};
